import React from 'react';
import { connect } from 'react-redux';
import Fingerprint2 from 'fingerprintjs2';
import { facebokLoginRequest, authLoginRequest, createUserRequest } from '../../../../action/auth-actions';
import './index.scss';
import { setLoading } from '../../../../action/loading-actions';

class FacebookLoginSignup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: '',
      lastName: '',
      email: '',
      fbToken: '',
      stateName: '',
      photoUrl: '',
      deviceId: '',
      platform: '',
      ipAddress: '',
      password: '',
      accessToken: false,
    };
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    // Get Device Information
    Fingerprint2.getV18({}, (result, components) => {
      const platform = components.find(c => c.key === 'platform')?.value || 'Unknown';
      this.setState({ platform });
    });

    // Initialize Facebook SDK
    window.fbAsyncInit = () => {
      FB.init({
        appId: __APP_ID__, // Replace with your Facebook App ID
        autoLogAppEvents: true,
        xfbml: true,
        version: 'v22.0', // keep in step with GraphApiVersion in services/FacebookTokenService.cs
      });
      FB.AppEvents.logPageView();
    };

    // Load the Facebook SDK
    (function (d, s, id) {
      const fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      const js = d.createElement(s);
      js.id = id;
      js.src = 'https://connect.facebook.net/en_US/sdk.js';
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');
  }

  handleClick() {
    FB.getLoginStatus(response => {
      if (response.status === 'connected') {
        this.fetchFacebookUserData(response.authResponse.accessToken);
      } else {
        FB.login(
          response => {
            if (response.authResponse) {
              this.fetchFacebookUserData(response.authResponse.accessToken);
            } else {
              console.warn('User cancelled login or did not fully authorize.');
            }
          },
          { scope: 'email,public_profile', return_scopes: true }
        );
      }
    });
  }

  fetchFacebookUserData(accessToken) {
    FB.api('/me?fields=id,name,picture,email', response => {
      if (response.error) {
        console.error('Error fetching user data:', response.error);
        return;
      }

      const [firstName, lastName] = response.name.split(' ');
      const profile = {
        firstName,
        lastName,
        email: response.email,
        photoUrl: response.picture.data.url,
        fbToken: accessToken,
      };
      this.setState(profile);

      // Built from the response rather than read back from this.state: React 18 batches
      // the setState above, so this.state still held the previous (empty) values here.
      this.props.FBlogin({ ...this.state, ...profile })
        .then(() => this.props.setLoading(true))
        .catch(err => {
          console.error('Login error:', err);
          if (this.props.onLoginError) this.props.onLoginError('facebook', profile.email, err);
        });
    });
  }

  render() {
    return (
      <div className="button-facebook">
        <button
          label="Login with Facebook"
          onClick={this.handleClick}
          style={{ margin: '1em 0' }}
        >
          <div style={{ display: 'flex', width: '100%' }}>
            <img src="../../../asset/Logo_Facebook-F_FFFFFFhdpi.png" />
            <span className="buttonText" style={{}}>Facebook</span>
          </div>
        </button>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
});

const mapDispatchToProps = dispatch => ({
  FBlogin: fbauthObj => dispatch(facebokLoginRequest(fbauthObj, { createUser: false })),
  authLogin: authObj => dispatch(authLoginRequest(authObj)),
  createUserLogin: userObj => dispatch(createUserRequest(userObj)),
  setLoading: bool => dispatch(setLoading(bool)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FacebookLoginSignup);
